import { gql } from "@apollo/client";

export const Get_Appointment_Members = gql`
  query GetAppointmentMembers($skip: Int, $take: Int) {
    members(skip: $skip, take: $take) {
      items {
        id
        name
        email
        alias
        userSsoEmail
        emailProviderType
        sessionId
        status
        createdOn
        modifiedOn
      }
      totalCount
    }
  }
`;

export const Get_Appointment_Calendars = gql`
  query GetAppointmentCalendars($skip: Int, $take: Int) {
    calendars(skip: $skip, take: $take, order: [{ createdOn: DESC }]) {
      items {
        id
        calendarLink
        uuid
        createdOn
        name
        timeZoneId
        description
        assignmentType
        status
        location
        duration
        durationUnit
        members {
          id
          name
          email
          alias
          userSsoEmail
          uuId
          status
        }
      }
      totalCount
    }
  }
`;
// reminderChannelStatuses
// appointmentReminders
export const Get_Appointment_Calendar_By_Id = gql`
  query GetCalendarById($id: Int!) {
    calendar(id: $id) {
      id
      durationUnit
      minimumBookingNotice
      minimumBookingNoticeUnit
      minimumCancelationNotice
      minimumCancelationNoticeUnit
      futureLimit
      futureLimitUnit
      bufferTime
      bufferTimeUnit
      calendarLink
      uuid
      location
      bookingPageTitle
      reminderChannelStatuses {
        id
        calendarId
        channelId
        status

        appointmentReminders {
          id
          reminderChannelStatusId
          recipientType
          beforeEventTime
          unit
        }
      }
      members {
        id
        name
        email
        status
      }
      createdOn
      modifiedOn
      name
      timeZoneId
      description
      assignmentType
      duration
      bookingLimit
      calendarJson
      isThirdPartySaved
      themeId
      theme {
        id
        color
        logoUrl
      }
      openingHours {
        id
        createdOn
        modifiedOn
        member
        openingHourId
        calendarId
        participantId
        days
        startHour
        startMinute
        endHour
        endMinute
        off
      }
      appointmentUserDefinedFields {
        id
        calendarId
        fieldLabel
        fieldKey
        fieldToolTipText
        isRequired
        sortOrder
      }
    }
  }
`;

export const Get_Connected_Calendars = gql`
  query GetConnectedCalendars($email: String!) {
    members(where: { email: { eq: $email } }) {
      items {
        id
        name
        email
        alias
        userSsoEmail
        emailProviderType
        sessionId
        status
        createdOn
        modifiedOn
      }
      totalCount
    }
  }
`;

export const Get_Lead_By_Filters = gql`
  query LeadsGridPagination(
    $skip: Int
    $take: Int
    $where: LeadGridFilterInput
    $order: [LeadGridSortInput!]
  ) {
    leadsGrid(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        firstName
        lastName
        email
        countryCode
        phone
        id
        salutation
      }
      totalCount
    }
  }
`;

export const Get_Availability_By_Date = gql`
  query GetAvailabilityByDate(
    $date: DateTime!
    $calendarId: String!
    $timeZoneId: String!
  ) {
    availableDate(
      date: $date
      calendarId: $calendarId
      timeZoneId: $timeZoneId
    ) {
      items {
        isAvailable
        errorMessage
      }
    }
  }
`;
export const Get_Slots_By_Date = gql`
  query GetSlotsByDate(
    $date: DateTime!
    $calendarId: String!
    $timeZoneId: String!
  ) {
    timeSlot(
      date: $date
      calendarId: $calendarId
      timeZoneId: $timeZoneId
      skip: 0
      take: 100
    ) {
      items {
        startHour
        startMinute
        endHour
        endMinute
        startDate
        endDate
        participantId
      }
    }
  }
`;

export const Get_Appointments = gql`
  query GetAppointments($skip: Int, $take: Int) {
    appointments(skip: $skip, take: $take) {
      items {
        id
        title
        timeZone
        status
        guest
        organizer
        serviceType
        calendarId
        title
        memberId
        participantId
        leadId
        startDate
        endDate
        notes
        meetingLocationType
        customMeetingLocation
      }
      totalCount
    }
  }
`;

export const Get_Appointments_By_Lead_Id = gql`
  query GetAppointmentsByLeadId($skip: Int, $take: Int, $leadId: Int!) {
    appointments(skip: $skip, take: $take, where: { leadId: { eq: $leadId } }) {
      items {
        id
        title
        timeZone
        status
        guest
        organizer
        serviceType
        calendarId
        title
        memberId
        participantId
        leadId
        startDate
        endDate
        notes
        meetingLocationType
        customMeetingLocation
      }
      totalCount
    }
  }
`;
